import { render, staticRenderFns } from "./NeedsUpdatesItem.vue?vue&type=template&id=0c3a02ab&scoped=true&"
import script from "./NeedsUpdatesItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsUpdatesItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a02ab",
  null
  
)

export default component.exports